module.exports = __webpack_public_path__ + "img/bg-sidekick.ed9f6c59.png";